import React from "react";
import "./GameSupergirls.css"; 
import "./CheckRewardLimit.css";

import { useNavigate } from "react-router-dom";
import headerImage from "../../assets/images/game-supergirls/TamhaRak_Poster.jpg";
import biggy from "../../assets/images/game-supergirls/Sticker-Thx.png";

const CheckRewardLimit = () => {
  const navigate = useNavigate();

  return (
    <div className="quiz-container">
      <img src={headerImage} alt="header" className="quiz-header-image" />

      <h2 className="limit-title">
        ขอบคุณที่ร่วมกิจกรรม
        <span className="limit-desc">
          ของรางวัลวันนี้แจกครบตามจำนวนแล้ว<br />
          ไว้มาร่วมสนุกกันใหม่วันพรุ่งนี้นะ
        </span>
      </h2>

      <img 
        src={biggy} 
        alt="Thank You" 
        className="limit-image" 
      />

      <div className="reward-button-wrapper">
        <button
          className="btn-back-limit"
          onClick={() => navigate("/")} 
        >
          กลับหน้าหลัก
        </button>
      </div>
    </div>
  );
};

export default CheckRewardLimit;